/** KAN-651: варианты-брифы первого сообщения: список и изменения. */
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { greetingVariantsApi } from '@/services/api/greetingVariants';
import { GREETING_AB_QUERY_KEY } from './useGreetingAb';

export const GREETING_VARIANTS_QUERY_KEY = ['telegram-greeting-variants'] as const;

/** KAN-752: ключ списка вариантов одного оператора (без него - все видимые). */
export function greetingVariantsKey(operatorId?: string) {
  return [...GREETING_VARIANTS_QUERY_KEY, operatorId ?? 'all'] as const;
}

export function useGreetingVariants(operatorId?: string) {
  return useQuery({
    queryKey: greetingVariantsKey(operatorId),
    queryFn: () => greetingVariantsApi.list(operatorId),
    staleTime: 30_000,
  });
}

/** Мутация, после которой обновляются список вариантов и статистика A/B (по префиксу ключей). */
function useInvalidatingMutation<TArgs, TResult>(fn: (args: TArgs) => Promise<TResult>) {
  const client = useQueryClient();
  return useMutation({
    mutationFn: fn,
    onSuccess: () => {
      client.invalidateQueries({ queryKey: GREETING_VARIANTS_QUERY_KEY });
      client.invalidateQueries({ queryKey: GREETING_AB_QUERY_KEY });
    },
  });
}

/** KAN-752: operatorId - чей вариант создаётся (карточка оператора). */
export function useGreetingVariantMutations(operatorId?: string) {
  return {
    create: useInvalidatingMutation((brief: string) =>
      greetingVariantsApi.create(operatorId ? { brief, operator_id: operatorId } : { brief })
    ),
    update: useInvalidatingMutation(
      (args: { id: number; brief?: string; enabled?: boolean }) =>
        greetingVariantsApi.update(args.id, { brief: args.brief, enabled: args.enabled })
    ),
    remove: useInvalidatingMutation((id: number) => greetingVariantsApi.remove(id)),
    generate: useInvalidatingMutation((args: { id: number; n: number }) =>
      greetingVariantsApi.generate(args.id, args.n)
    ),
    updateText: useInvalidatingMutation(
      (args: { id: number; text?: string; enabled?: boolean }) =>
        greetingVariantsApi.updateText(args.id, { text: args.text, enabled: args.enabled })
    ),
    removeText: useInvalidatingMutation((id: number) => greetingVariantsApi.removeText(id)),
  };
}
